'use client';

import { BlurSwap } from '../../collection-showcase/scenes/playback-controls.jsx';
import { ShowcaseIcon } from '../../collection-showcase/scenes/scene-primitives.jsx';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import {
  ShowcaseCopyContext,
  translateShowcaseNode,
} from '../../collection-showcase/translation';
import { rr, AppSourceBadge, AppMetric, ir, ar, sr, or } from './app-window';
import { me } from './business-facts';
export function LinePlanner({ onInteract: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let [t, n] = React.useState('All'),
    r = rr.rows.filter((e) => t === 'All' || e.status === t);
  return (
    <div className={'h-full overflow-hidden px-4 pt-4 pb-24 md:px-6 md:pt-5'}>
      <div className={'enter flex items-start justify-between gap-4'}>
        <div>
          <p
            className={
              'text-ink font-[Georgia,serif] text-[24px] leading-none tracking-[0.3em] md:text-[30px]'
            }
          >
            {translateShowcaseNode(showcaseCopy, 'HALDEN')}
          </p>
          <span className={'mt-2.5 block h-[1.5px] w-9 bg-[#B86B4B]'} />
          <p className={'text-ink-3 mt-2 text-[13px]'}>
            {translateShowcaseNode(showcaseCopy, 'SS27 linen line planner')}
          </p>
        </div>
        <div className={'flex flex-col items-end gap-2'}>
          <span className={'btn btn-ink max-sm:hidden'}>
            {translateShowcaseNode(showcaseCopy, 'Add style')}
          </span>
          <AppSourceBadge kind={'real'} />
        </div>
      </div>
      <dl
        className={
          'enter mt-4 grid grid-cols-2 gap-2 sm:grid-cols-3 xl:grid-cols-6'
        }
        style={{
          '--i': '1',
        }}
      >
        <AppMetric label={'Styles'} value={String(rr.styles)} />
        <AppMetric label={'Avg. margin'} value={`${rr.avgMargin}%`} />
        {translateShowcaseNode(
          showcaseCopy,
          ir.map((e) => (
            <AppMetric
              key={e}
              label={e}
              value={String(rr.byStatus[e])}
              className={'max-sm:hidden'}
            />
          ))
        )}
      </dl>
      <div
        className={'enter mt-4 flex items-center justify-between gap-3'}
        style={{
          '--i': '2',
        }}
      >
        <div
          role={'group'}
          aria-label={translateShowcaseNode(showcaseCopy, 'Filter by status')}
          className={
            'flex overflow-hidden rounded-md shadow-[inset_0_0_0_1px_var(--border)]'
          }
        >
          {translateShowcaseNode(
            showcaseCopy,
            ar.map((r, i) => (
              <button
                key={r}
                type={'button'}
                aria-pressed={t === r}
                onClick={() => {
                  (e(), n(r));
                }}
                className={`h-10 px-3 text-[13px] whitespace-nowrap transition-colors duration-150 sm:h-8 ${i > 0 ? 'border-l border-[var(--border)]' : ''} ${i > 2 ? 'max-sm:hidden' : ''} ${t === r ? 'text-ink bg-[var(--muted)]' : 'text-ink-2 hover:bg-[var(--hover-wash)]'}`}
              >
                {translateShowcaseNode(showcaseCopy, r)}
              </button>
            ))
          )}
        </div>
        <span className={'text-ink-3 hidden text-[12px] sm:block'}>
          {translateShowcaseNode(showcaseCopy, 'Summary covers the whole line')}
        </span>
      </div>
      <table
        className={
          'enter mt-3 w-full table-fixed border-collapse text-left text-[13px]'
        }
        style={{
          '--i': '3',
        }}
      >
        <thead>
          <tr className={'h-10 border-b border-[var(--border)]'}>
            <th className={`${sr} w-[46%] font-normal sm:w-[28%]`}>
              {translateShowcaseNode(showcaseCopy, 'Style')}
            </th>
            <th className={`${sr} hidden font-normal lg:table-cell`}>
              {translateShowcaseNode(showcaseCopy, 'Category')}
            </th>
            <th className={`${sr} hidden font-normal sm:table-cell`}>
              {translateShowcaseNode(showcaseCopy, 'Colourway')}
            </th>
            <th className={`${sr} hidden text-right font-normal xl:table-cell`}>
              {translateShowcaseNode(showcaseCopy, 'Target retail')}
            </th>
            <th className={`${sr} hidden text-right font-normal xl:table-cell`}>
              {translateShowcaseNode(showcaseCopy, 'Est. cost')}
            </th>
            <th className={`${sr} text-right font-normal`}>
              {translateShowcaseNode(showcaseCopy, 'Margin')}
            </th>
            <th className={`${sr} w-[34%] pl-4 font-normal sm:w-[22%]`}>
              {translateShowcaseNode(showcaseCopy, 'Status')}
            </th>
          </tr>
        </thead>
        <tbody key={t} className={'num'}>
          {translateShowcaseNode(
            showcaseCopy,
            r.map((e, t) => (
              <tr
                key={e.style}
                className={'enter h-12 border-b border-[var(--border)]'}
                style={{
                  '--i': String(t),
                }}
              >
                <td
                  className={
                    'text-ink truncate pr-2 font-[Georgia,serif] text-[15px] md:text-[16px]'
                  }
                >
                  {translateShowcaseNode(showcaseCopy, e.style)}
                </td>
                <td className={'text-ink-2 hidden lg:table-cell'}>
                  {translateShowcaseNode(showcaseCopy, e.category)}
                </td>
                <td className={'hidden sm:table-cell'}>
                  <span className={'text-ink-2 flex items-center gap-2'}>
                    <span
                      className={
                        'size-2.5 rounded-full shadow-[inset_0_0_0_1px_rgb(0_0_0/0.12)]'
                      }
                      style={{
                        backgroundColor: or.get(e.colour),
                      }}
                    />
                    {translateShowcaseNode(showcaseCopy, e.colour)}
                  </span>
                </td>
                <td className={'text-ink-2 hidden text-right xl:table-cell'}>
                  {translateShowcaseNode(showcaseCopy, '$')}
                  {translateShowcaseNode(showcaseCopy, e.retail)}
                </td>
                <td className={'text-ink-2 hidden text-right xl:table-cell'}>
                  {translateShowcaseNode(showcaseCopy, '$')}
                  {translateShowcaseNode(showcaseCopy, e.cost)}
                </td>
                <td className={'text-ink text-right'}>
                  {translateShowcaseNode(showcaseCopy, e.margin)}
                  {translateShowcaseNode(showcaseCopy, '%')}
                </td>
                <td className={'pl-4'}>
                  <span
                    className={
                      'text-ink flex h-9 items-center justify-between rounded-md px-3 text-[13px] shadow-[inset_0_0_0_1px_var(--border)]'
                    }
                  >
                    <span className={'truncate'}>
                      {translateShowcaseNode(showcaseCopy, e.status)}
                    </span>
                    <ShowcaseIcon
                      name={'chevronDown'}
                      className={'text-ink-3 size-3.5 shrink-0'}
                    />
                  </span>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      <p className={'num text-ink-4 mt-2 text-[12px]'}>
        {translateShowcaseNode(showcaseCopy, 'Showing ')}
        <BlurSwap value={`${r.length}`} />
        {translateShowcaseNode(showcaseCopy, ' of ')}
        {translateShowcaseNode(showcaseCopy, rr.styles)}
        {translateShowcaseNode(showcaseCopy, ' styles')}
      </p>
    </div>
  );
}
export const ur = 8508;
export const dr = Object.fromEntries(me.totals.map((e) => [e.label, e.value]));
export function fr(e) {
  return {
    received: (dr['Deposits received'] ?? 0) - (e.tsukiReceived ? 0 : ur),
    outstanding: (dr['Deposits outstanding'] ?? 0) + (e.tsukiReceived ? 0 : ur),
    overdue: (dr['Overdue deposits'] ?? 0) - +!e.brunOverdue,
  };
}
export function pr(e, t) {
  return e.account === 'Atelier Brun'
    ? t.brunOverdue
      ? 'overdue'
      : 'due'
    : e.account === 'Tsuki Select'
      ? t.tsukiReceived
        ? 'paid'
        : 'due'
      : e.deposit;
}
export const mr = (e) => `$${Math.round(e).toLocaleString('en-US')}`;
export function DepositStatus({ deposit: e, dueDate: t }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <span
      key={e}
      className={`bz-cell-in inline-flex h-[22px] items-center rounded-full px-2 text-[11.5px] font-medium whitespace-nowrap ${e === 'overdue' ? 'bg-[color-mix(in_srgb,oklch(0.6_0.2_25)_14%,transparent)] text-[oklch(0.52_0.19_25)]' : 'text-ink-2 bg-[var(--muted)]'}`}
    >
      {translateShowcaseNode(
        showcaseCopy,
        e === 'paid'
          ? 'Paid'
          : e === 'overdue'
            ? 'Overdue'
            : t
              ? 'Due Oct 10'
              : 'Due'
      )}
    </span>
  );
}
